// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/bulkaction/v1/bulkaction.proto" (package "c1.api.bulkaction.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { BulkActionService } from "./bulkaction";
import type { BulkActionListCompletedItemsResponse } from "./bulkaction";
import type { BulkActionListCompletedItemsRequest } from "./bulkaction";
import type { BulkActionListItemsResponse } from "./bulkaction";
import type { BulkActionListItemsRequest } from "./bulkaction";
import type { Empty } from "../../../../google/protobuf/empty";
import type { BulkActionDeleteRequest } from "./bulkaction";
import type { BulkActionCreateRequest } from "./bulkaction";
import type { BulkAction } from "./bulkaction";
import type { BulkActionGetRequest } from "./bulkaction";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { BulkActionListResponse } from "./bulkaction";
import type { BulkActionListRequest } from "./bulkaction";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.bulkaction.v1.BulkActionService
 */
export interface IBulkActionServiceClient {
    /**
     * @generated from protobuf rpc: ListBulkAction
     */
    listBulkAction(input: BulkActionListRequest, options?: RpcOptions): UnaryCall<BulkActionListRequest, BulkActionListResponse>;
    /**
     * @generated from protobuf rpc: GetBulkAction
     */
    getBulkAction(input: BulkActionGetRequest, options?: RpcOptions): UnaryCall<BulkActionGetRequest, BulkAction>;
    /**
     * @generated from protobuf rpc: CreateBulkAction
     */
    createBulkAction(input: BulkActionCreateRequest, options?: RpcOptions): UnaryCall<BulkActionCreateRequest, BulkAction>;
    /**
     * @generated from protobuf rpc: DeleteBulkAction
     */
    deleteBulkAction(input: BulkActionDeleteRequest, options?: RpcOptions): UnaryCall<BulkActionDeleteRequest, Empty>;
    /**
     * @generated from protobuf rpc: ListBulkActionItems
     */
    listBulkActionItems(input: BulkActionListItemsRequest, options?: RpcOptions): UnaryCall<BulkActionListItemsRequest, BulkActionListItemsResponse>;
    /**
     * @generated from protobuf rpc: ListCompletedBulkActionItems
     */
    listCompletedBulkActionItems(input: BulkActionListCompletedItemsRequest, options?: RpcOptions): UnaryCall<BulkActionListCompletedItemsRequest, BulkActionListCompletedItemsResponse>;
}
/**
 * @generated from protobuf service c1.api.bulkaction.v1.BulkActionService
 */
export class BulkActionServiceClient implements IBulkActionServiceClient, ServiceInfo {
    typeName = BulkActionService.typeName;
    methods = BulkActionService.methods;
    options = BulkActionService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ListBulkAction
     */
    listBulkAction(input: BulkActionListRequest, options?: RpcOptions): UnaryCall<BulkActionListRequest, BulkActionListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkActionListRequest, BulkActionListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBulkAction
     */
    getBulkAction(input: BulkActionGetRequest, options?: RpcOptions): UnaryCall<BulkActionGetRequest, BulkAction> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkActionGetRequest, BulkAction>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateBulkAction
     */
    createBulkAction(input: BulkActionCreateRequest, options?: RpcOptions): UnaryCall<BulkActionCreateRequest, BulkAction> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkActionCreateRequest, BulkAction>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteBulkAction
     */
    deleteBulkAction(input: BulkActionDeleteRequest, options?: RpcOptions): UnaryCall<BulkActionDeleteRequest, Empty> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkActionDeleteRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListBulkActionItems
     */
    listBulkActionItems(input: BulkActionListItemsRequest, options?: RpcOptions): UnaryCall<BulkActionListItemsRequest, BulkActionListItemsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkActionListItemsRequest, BulkActionListItemsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCompletedBulkActionItems
     */
    listCompletedBulkActionItems(input: BulkActionListCompletedItemsRequest, options?: RpcOptions): UnaryCall<BulkActionListCompletedItemsRequest, BulkActionListCompletedItemsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkActionListCompletedItemsRequest, BulkActionListCompletedItemsResponse>("unary", this._transport, method, opt, input);
    }
}
